import React from 'react';
import { SettingsView } from '@/features/shared/settings/components/SettingsView';

/**
 * Admin Settings Tab
 * Wrapper for shared SettingsView component
 */
export const SettingsTab: React.FC = () => {
  return <SettingsView />;
};
